module.exports = __webpack_public_path__ + "media/images/onboarding-2-56f0281213a6964b6c96f4396a1d5d55.webp";